import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testing"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 3 }

import { mdiAlert, mdiProgressAlert } from "@mdi/js";
import { computed } from "vue";

import { sanitizeHtml } from "@/utils/sanitize-html";


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
  type: {
    default: "error",
    required: false,
    type: String,
    validator: (value: string) => {
      return ["warning", "error", "info"].includes(value);
    }
  },
  dataTesting: {
    required: false,
    type: String,
    default: ""
  },
  message: {
    required: true,
    type: String
  },
  isHtml: {
    required: false,
    default: false,
    type: Boolean
  }
},
  setup(__props) {

const props = __props;

const sanitizedMessage = computed<string>(() => sanitizeHtml(props.message));

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass([`${__props.type}-message`, 'pad-0-bottom']),
    "data-testing": __props.dataTesting
  }, [
    (__props.type === 'info')
      ? (_openBlock(), _createBlock(_component_SVGIcon, {
          key: 0,
          path: _unref(mdiProgressAlert)
        }, null, 8, ["path"]))
      : (_openBlock(), _createBlock(_component_SVGIcon, {
          key: 1,
          path: _unref(mdiAlert)
        }, null, 8, ["path"])),
    (__props.isHtml)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          innerHTML: sanitizedMessage.value
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.message), 1))
  ], 10, _hoisted_1))
}
}

})